import { getLoginRoute } from "app/authv2/use-session"
/* eslint-disable @next/next/no-img-element */
import Logo from "public/Icon_Dark_Mode.svg"
import { FC, PropsWithChildren, useState } from "react"
const navigation = [
  {
    title: "Legal",
    links: [
      { title: "Privacy Policy", url: "/privacy" },
      { title: "Terms of Use", url: "/privacy/terms" },
      { title: "GDPR", url: "/privacy/gdpr" },
      { title: "DPA", url: "/privacy/dpa" },
    ],
  },
  {
    title: "Product",
    links: [
      { title: "Sign Up", url: "/signup" },
      { title: "Log In", url: getLoginRoute() },
      { title: "Pricing", url: "/#pricing-anchor" },
      { title: "System Status", url: "https://status.superwall.com" },
    ],
  },
  {
    title: "Company",
    links: [
      { title: "Twitter", url: "https://twitter.com/superwall" },
      { title: "team@superwall.com", url: "mailto:team@superwall.com?subject=Superwall%20Inquiry" },
      { title: "Book a demo", url: "/contact/book-a-demo" },
      {
        title: "Careers",
        url: "mailto:team@superwall.com?subject=Open%20positions%20at%20Superwall",
      },
    ],
  },
  {
    title: "Resources",
    links: [
      { title: "Docs", url: "https://docs.superwall.com" },
      { title: "SDK Reference", url: "https://sdk.superwall.me/" },
      { title: "GitHub", url: "https://github.com/superwall" },
      { title: "Inspiration", url: "https://paywallscreens.com" },
    ],
  },
]

const Footer: FC<PropsWithChildren<{}>> = () => {
  const [isHovering, setIsHovering] = useState(false)

  return (
    <>
      <footer className="bg-darker tracking-tight">
        <div
          className={`h-[1px] w-[100%] bg-gradient-to-r from-sky-300/0 via-purple-200/20 to-sky-300/0`}
        ></div>
        <div className="">
          <div className="max-w-8xl mx-auto w-full flex flex-col lg:flex-row justify-between py-6 lg:py-20 lg:items-start gap-4 lg:gap-20 px-10">
            <a href="/" className="flex order-first lg:order-none lg:translate-y-[-13px]">
              {/* @ts-ignore */}
              <img style={{ height: "75px", width: "auto" }} src={Logo.src} alt="Superwall" />
            </a>
            <div className="lg:max-w-4xl ml-auto w-full flex flex-wrap md:flex-row justify-between items-start gap-y-8">
              {navigation.map((section) => {
                return (
                  <div key={section.title} className="w-1/2 sm:w-auto">
                    <h3 className="text-sm font-medium text-gray-400 dark:text-gray-300 tracking-wider uppercase">
                      {section.title}
                    </h3>
                    <ul className="mt-2 lg:mt-4 space-y-2 lg:space-y-4">
                      {section.links.map((link) => (
                        <li key={link.title}>
                          <a
                            target="_blank"
                            rel="noopenerer noreferrer"
                            href={link.url}
                            className="transition focus:outline-none opacity-40 hover:text-brand-primary hover:opacity-100"
                          >
                            {link.title}
                          </a>
                        </li>
                      ))}
                    </ul>
                  </div>
                )
              })}
            </div>
          </div>
          <div className="w-full py-10  border-t border-white border-opacity-7">
            <div className="max-w-8xl mx-auto w-full flex flex-row justify-between px-10">
              <p
                onMouseEnter={() => setIsHovering(true)}
                onMouseLeave={() => setIsHovering(false)}
                className="hidden lg:block text-base  text-center"
              >
                <span className="opacity-20">
                  Built with <span className="inline mx-[0.05rem]">{HeartIcon}</span> in CA, NY, WA,
                  NV, MO, Bali &
                </span>
                <span
                  className={`transition-all text-white ${
                    isHovering ? "opacity-90" : "opacity-20"
                  }`}
                >
                  {" "}
                  Stratford-upon-Avon
                </span>
                <span className="opacity-20">.</span>
                <span
                  className={`transition-all text-brand-primary ${
                    isHovering ? "opacity-90" : "opacity-0"
                  }`}
                >
                  {" ← Where Shakespeare is from"}
                </span>
              </p>
              <p className="text-base opacity-20 text-center">
                {`© ${new Date().getFullYear()} Superwall. All rights reserved.`}
              </p>
            </div>
          </div>
        </div>
      </footer>
    </>
  )
}

const HeartIcon = (
  <svg
    className="inline mb-[5px]"
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 16 16"
  >
    <title>hearts-suit</title>
    <g fill="currentColor">
      <path
        d="M11,2A3.944,3.944,0,0,0,8,3.371,3.944,3.944,0,0,0,5,2,4,4,0,0,0,2.135,8.785l5.508,5.629a.5.5,0,0,0,.357.15H8a.5.5,0,0,0,.358-.151l5.315-5.454A3.988,3.988,0,0,0,11,2Z"
        fill="currentColor"
      ></path>
    </g>
  </svg>
)

export default Footer
